import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FaPlus, FaCopy } from 'react-icons/fa';
import TimeSlot from './TimeSlot';

const DayRow = ({
  dayData, // Contains { id, dayName, initial, slots }
  onAddTimeSlot,
  onRemoveTimeSlot,
  onTimeChange,
  onCopy,
}) => {
  const { id, dayName, initial, slots } = dayData;

  return (
    <Card className="mb-3">
      <Card.Body className="p-3">
        <div className="d-flex align-items-start flex-wrap gap-3">
          <div
            className={`p-2 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 ${slots.length > 0 ? 'bg-primary text-white' : 'bg-light text-muted'
              }`}
            style={{ width: '40px', height: '40px' }}
          >
            <span className="fw-bold fs-6">{initial}</span>
          </div>
          <div className="flex-grow-1 min-w-0">
            <h6 className="mb-2 fw-semibold">{dayName}</h6>
            {slots.length === 0 ? (
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <span className="text-muted">Unavailable</span>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => onAddTimeSlot(id)}
                >
                  <FaPlus className="me-1" /> Add Time Slot
                </Button>
              </div>
            ) : (
              <>
                {slots.map((slot, index) => (
                  <TimeSlot
                    key={index}
                    slot={slot}
                    index={index}
                    onTimeChange={(field, value) => onTimeChange(id, index, field, value)}
                    onRemove={() => onRemoveTimeSlot(id, index)}
                  />
                ))}
                <div className="d-flex flex-wrap gap-2 mt-2">
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={() => onAddTimeSlot(id)}
                  >
                    <FaPlus className="me-1" /> Add Slot
                  </Button>
                  {/* <Button variant="outline-secondary" size="sm" onClick={() => onCopy(id)}>
                    <FaCopy className="me-1" /> Copy
                  </Button> */}
                </div>
              </>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DayRow;